export const enumCodePartner = {
    NONE : 0,
    UPE06 : 1
}